export default "__VITE_ASSET__444b813b__"